// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cfff0379","455":"f33ec2d7","488":"da50ae29"}[chunkId] + ".chunk.js";
};